export const REQUESTED = 'requested'
export const PENDING = 'pending'
export const IN_PROGRESS = 'in progress'
export const COMPLETED = 'completed'
export const CANCELLED = 'cancelled'
export const DRAFT = 'draft'
export const ANALYZING = 'analyzing'
